import BaseService from '../services/BaseService';

/** Labels alinhados a TipoEquipamentoSelectV2 / enum BE. */
export const TIPO_EQUIPAMENTO_NOME = {
  ALICATE_HIDRAULICO: 'Alicate Hidráulico',
  CAMERA_FOTOGRAFICA: 'Câmera Fotográfica',
  CELULAR: 'Celular',
  CHIP: 'Chip',
  DRONE: 'Drone',
  GPS: 'GPS',
  IPAD: 'iPad',
  MONITOR: 'Monitor',
  NOTEBOOK: 'Notebook',
  RADIO: 'Rádio',
  TERMOVISOR: 'Termovisor',
};

export const tipoEquipamentoNome = (tipo) =>
  TIPO_EQUIPAMENTO_NOME[tipo] || tipo || 'Outros';

/**
 * Normaliza `EquipamentoModeloResponse[]` ({ tipoEquipamento, modelo })
 * ou formatos legados (List<String> / { rows }).
 */
export const mapEquipamentoModeloOptions = (payload) => {
  const list = Array.isArray(payload)
    ? payload
    : (payload && Array.isArray(payload.rows) ? payload.rows : []);

  return list
    .map((item) => {
      if (typeof item === 'string') {
        const modelo = item.trim();
        return modelo
          ? { value: modelo, label: modelo, tipoEquipamento: null, group: null }
          : null;
      }
      if (!item || typeof item !== 'object') return null;

      const modelo = String(item.modelo || item.nome || item.label || item.value || '').trim();
      if (!modelo) return null;

      const tipo = item.tipoEquipamento || null;
      return {
        value: modelo,
        label: modelo,
        tipoEquipamento: tipo,
        group: tipo ? tipoEquipamentoNome(tipo) : null,
      };
    })
    .filter(Boolean);
};

export const filterModeloOptionsByTipo = (options, tipoEquipamento) => {
  if (!tipoEquipamento) return options || [];
  return (options || []).filter((option) => option.tipoEquipamento === tipoEquipamento);
};

/**
 * @param {string} [tipoEquipamento] — opcional; form deve passar o tipo.
 */
export async function fetchEquipamentoModelos(tipoEquipamento) {
  const query = tipoEquipamento
    ? `?tipoEquipamento=${encodeURIComponent(tipoEquipamento)}`
    : '';
  const response = await BaseService.get({
    url: `equipamentos/modelos${query}`,
  });
  return mapEquipamentoModeloOptions(response?.data);
}
